import { v4 as Uuid } from "uuid";

export default {
  createNewEmptyRule() {
    let newCriterion = this.createNewEmptyCriterion();
    let newRule = {
      file_job_id: Uuid(),
      title: "",
      volume: "",
      device: "",
      collection_type: "Enterprise",
      price_per_gb: 5.0,
      criteria: [],
    };
    newRule.criteria.push(newCriterion);
    return newRule;
  },

  createNewEmptyCriterion() {
    return {
      fileJobElementId: Uuid(),
      noun: this.fileRuleNouns[0].noun,
      modifier: this.fileRuleNouns[0].validModifiers[0],
      value: 0,
      uom: this.fileRuleNouns[0].uom[0],
    };
  },

  fileRuleNouns: [
    {
      noun: "file-size",
      uom: ["MB", "KB", "GB"],
      validModifiers: ["greater-than", "less-than", "equal-to"],
    },
    {
      noun: "age",
      uom: "days",
      validModifiers: ["greater-than", "less-than", "equal-to"],
    },
    {
      noun: "days-since-last-access",
      uom: "days",
      validModifiers: ["greater-than", "less-than", "equal-to"],
    },
    {
      noun: "file-name",
      uom: null,
      validModifiers: ["starts-with", "ends-with", "contains"],
    },
  ],
  cliDevices: [
    "VNX_DEVICE",
    "TEST_VNX_DEVICE",
    "CLARIION_DEVICE",
    "ESERIES_DEVICE",
    "TEST_ESERIES_DEVICE",
    "DS3K_DEVICE",
    "TSM_BACKUP",
  ],
  portDevices: ["TSM", "MSSQLSERVER_DATABASE"],
  threeParDevices: [
    "THREE_PAR_DEVICE",
    "TEST_THREE_PAR_DEVICE",
    "THREE_PAR_API_DEVICE",
  ],
  CohesityDevices: [
    "COHESITY_BACKUP",
    "COHESITY_DEVICE",
    "TEST_COHESITY_DEVICE",
  ],
  TokenInVaultDevices: [
    // Devices which require to
    // (a) display password as Api Token but still store in password field to work with windows vault
    // (b) delete it on our side once it's stored on customer side
    // (c) work without double confirmation interaction when adding/modifying the field.
    "FLASHBLADE_DEVICE",
  ],
  FileAnalysisDevice: [
    "FILE_ANALYSIS",
    "TEST_FILE_ANALYSIS",
  ],
  days: [
    { value: "mon", label: "Monday" },
    { value: "tue", label: "Tuesday" },
    { value: "wed", label: "Wednesday" },
    { value: "thurs", label: "Thursday" },
    { value: "fri", label: "Friday" },
    { value: "sat", label: "Saturday" },
    { value: "sun", label: "Sunday" },
  ],
};
